import React from 'react';
import PropTypes from 'prop-types';

import './ItemTags/index.scss';

const ItemTagsFlatRenderer = (props) => {
  const { section, tags, reactKey } = props;
  const key = `${reactKey}_sublist`;
  // PREAP-1652: tag.value is now an array from the api, so it must be joined by a comma in this case
  // it's iterated in other parts of the API (i.e. Assessment Summary)
  return (
    <div className="ItemTagsFlatRenderer">
      <div className="ItemMetadata__section__header">
        <h3>{section.header}</h3>
      </div>
      <div className="ItemMetadata__section__content">
        <ul key={key}>
          {_(tags)
            .map((tag, index) => (
              <li key={index}>
                <strong>
                  <label>{tag.title}</label>
                </strong>
                :{' '}
                {tag.value &&
                  (typeof tag.value === 'string'
                    ? tag.value
                    : tag.value.join(', '))}
              </li>
            ))
            .value()}
        </ul>
      </div>
    </div>
  );
};

ItemTagsFlatRenderer.displayName = 'ItemTagsFlatRenderer';

ItemTagsFlatRenderer.propTypes = {
  section: PropTypes.object,
  tags: PropTypes.array,
  reactKey: PropTypes.string,
};

export default ItemTagsFlatRenderer;
